// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationFaceIdPath = 'M12 27H5V15.5C5 9.701 9.701 5 15.5 5H27v7H15.5a3.5 3.5 0 00-3.5 3.5V27zm28 16a5 5 0 11-10 0 5 5 0 0110 0zm31 0a5 5 0 11-10 0 5 5 0 0110 0zM31.3 68.8A22.2 22.2 0 0050 79.1a22.2 22.2 0 0018.7-10.3l-6-3.8a14.9 14.9 0 01-25.4 0l-6 3.8zM15.5 95H27v-7H15.5a3.5 3.5 0 01-3.5-3.5V73H5v11.5C5 90.299 9.701 95 15.5 95zm69 0H73v-7h11.5a3.5 3.5 0 003.5-3.5V73h7v11.5C95 90.299 90.299 95 84.5 95zM88 27h7V15.5C95 9.701 90.299 5 84.5 5H73v7h11.5a3.5 3.5 0 013.5 3.5V27zM43.5 63h-1v-7h1a3.5 3.5 0 003.5-3.5V43c-.054-6.329-5.171-11.446-11.5-11.5a11.4 11.4 0 00-6.9 2.3l-4.2-5.6A18.5 18.5 0 0154 43v9.5C54 58.299 49.299 63 43.5 63zm22-31.5a11.4 11.4 0 016.9 2.3l4.2-5.6a18.5 18.5 0 00-11.1-3.7 17.9 17.9 0 00-10.3 3.2l3.9 5.8a11.3 11.3 0 016.4-2z';
var IllustrationFaceId = baseIllustration('IllustrationFaceId', {
  getPath: () => IllustrationFaceIdPath
}, 'ColoredIllustrationFaceId');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationFaceId;
//# sourceMappingURL=index.js.map